import React from 'react'
import MuiThemeProvider from './providers/ThemeProvider'
import Home from './pages/Home'

export default function App() {
  return (
    <MuiThemeProvider>
      <Home />
    </MuiThemeProvider>
  )
}
